import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Toaster from './common/toaster';

// REDUX
import { Provider } from 'react-redux';
import store from './redux/store';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Toaster />
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

